// extracted by mini-css-extract-plugin
export default {"cls1":"PostEngagementFollowPrompt-cls1___318b58dd660c6dba4b6","cls2":"PostEngagementFollowPrompt-cls2___dfd95f9c383a9ddfa2b PostEngagementFollowPrompt-cls1___318b58dd660c6dba4b6"};